import makeStyles from '@material-ui/core/styles/makeStyles';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      fill: 'none',
    },
  }),
  { name: 'THome' }
);

const THome: FC<SvgIconProps> = (props) => {
  const classes = useStyles();
  return (
    <SvgIcon
      className={classes.root}
      fill="none"
      height="19"
      viewBox="0 0 23 19"
      width="23"
      {...props}
    >
      <rect height="18" rx="1.5" stroke="#ACB5BD" width="21" x="1" y="0.5" />
      <path
        d="M11.877 14.0561C11.657 14.0561 11.481 13.9938 11.349 13.8691C11.2243 13.7371 11.162 13.5648 11.162 13.3521V7.41209H9.16C8.72 7.41209 8.5 7.21776 8.5 6.82909C8.5 6.44043 8.72 6.24609 9.16 6.24609H14.583C15.023 6.24609 15.243 6.44043 15.243 6.82909C15.243 7.21776 15.023 7.41209 14.583 7.41209H12.581V13.3521C12.581 13.5648 12.515 13.7371 12.383 13.8691C12.2583 13.9938 12.0897 14.0561 11.877 14.0561Z"
        fill="#ACB5BD"
      />
    </SvgIcon>
  );
};

export default THome;
